var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"osechi"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"cover"},[_c('OsechiNote')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }